import React from 'react';
import { getVariantNames } from '../useDesignVariants';

const StyleSwitcher = ({ currentVariant, onVariantChange, styles }) => {
  const variants = getVariantNames();

  return (
    <div className={`fixed top-4 right-4 bg-white p-6 ${styles.shadow} ${styles.rounded} border ${styles.borderColor} z-40 w-80`}>
      <h3 className={`text-lg ${styles.fontWeight} mb-4`}>Design Variant</h3>

      <select
        value={currentVariant}
        onChange={(e) => onVariantChange(e.target.value)}
        className={`w-full px-3 py-2 border ${styles.borderColor} ${styles.rounded} ${styles.fontSize} focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4`}
      >
        {variants.map(variant => (
          <option key={variant.id} value={variant.id}>
            {variant.name}
          </option>
        ))}
      </select>

      <div className={`mt-4 text-xs ${styles.fontWeight} space-y-2 border-t ${styles.borderColor} pt-4`}>
        <h4 className="text-sm font-bold mb-2">Current CSS Values:</h4>
        <div className="space-y-1 font-mono text-gray-700">
          <p><span className="text-gray-500">Icon Size:</span> {styles.iconSize}</p>
          <p><span className="text-gray-500">Icon BG:</span> {styles.iconBg || 'none'}</p>
          <p><span className="text-gray-500">Icon Color:</span> {styles.iconColor}</p>
          <p><span className="text-gray-500">Stroke Width:</span> {styles.strokeWidth}</p>
          <p><span className="text-gray-500">Font Weight:</span> {styles.fontWeight}</p>
          <p><span className="text-gray-500">Font Size:</span> {styles.fontSize}</p>
          <p><span className="text-gray-500">Shadow:</span> {styles.shadow}</p>
          <p><span className="text-gray-500">Rounded:</span> {styles.rounded}</p>
          <p><span className="text-gray-500">Tracking:</span> {styles.tracking}</p>
          {styles.leftBorder && <p><span className="text-gray-500">Left Border:</span> {styles.leftBorder}</p>}
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-gray-200">
        <p className="text-xs text-gray-500">
          Switch between variants to find your preferred design. Once selected, these exact CSS values can be applied app-wide.
        </p>
      </div>
    </div>
  );
};

export default StyleSwitcher;
